import { useState } from "react";

import { itemKey } from "../summaryRules";
import { formatNumber } from "../format";

const emptyRow = () => ({});

export default function LineItemsForm({ columns, getColumnOptions, onCreate }) {
  const [rows, setRows] = useState([emptyRow()]);
  const [error, setError] = useState("");

  const setCell = (rowIndex, column, value) => {
    setRows((current) =>
      current.map((row, index) =>
        index === rowIndex ? { ...row, [itemKey(column)]: value } : row
      )
    );
  };

  const addRow = () => setRows((current) => [...current, emptyRow()]);

  const removeRow = (rowIndex) =>
    setRows((current) =>
      current.length === 1 ? current : current.filter((_, index) => index !== rowIndex)
    );

  const amountColumn = columns.find((column) => column.key === "amount" || column.format === "number");

  const total = amountColumn
    ? rows.reduce((sum, row) => {
        const n = Number(String(row[itemKey(amountColumn)] ?? "").replace(",", ".").trim());
        return sum + (Number.isNaN(n) ? 0 : n);
      }, 0)
    : null;

  const isRowEmpty = (row) =>
    columns.every((column) => String(row[itemKey(column)] ?? "").trim() === "");

  const submit = async () => {
    const items = rows.filter((row) => !isRowEmpty(row));

    if (items.length === 0) {
      setError("Добавьте хотя бы одну строку");
      return;
    }

    const missing = columns.find((column) =>
      column.required && items.some((row) => String(row[itemKey(column)] ?? "").trim() === "")
    );

    if (missing) {
      setError(`Не заполнен обязательный столбец во всех строках: ${missing.label}`);
      return;
    }

    setError("");
    const created = await onCreate(items);

    if (created) {
      setRows([emptyRow()]);
    }
  };

  const renderCell = (column, row, rowIndex) => {
    const value = row[itemKey(column)] ?? "";
    const options = getColumnOptions(column);

    if (options) {
      return (
        <select value={value} onChange={(e) => setCell(rowIndex, column, e.target.value)}>
          <option value="">{column.label}</option>
          {options.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      );
    }

    return (
      <input
        value={value}
        placeholder={column.required ? `${column.label} *` : column.label}
        type={column.format === "date" ? "date" : "text"}
        inputMode={column.format === "number" ? "decimal" : undefined}
        onChange={(e) => setCell(rowIndex, column, e.target.value)}
      />
    );
  };

  return (
    <div className="line-items-form">
      <table className="line-items-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.id}>{column.label}</th>
            ))}
            <th></th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td key={column.id}>{renderCell(column, row, rowIndex)}</td>
              ))}
              <td>
                <button
                  className="line-item-remove"
                  disabled={rows.length === 1}
                  title="Удалить строку"
                  onClick={() => removeRow(rowIndex)}
                >
                  &#10005;
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="line-items-actions">
        <button className="secondary-action-btn" onClick={addRow}>
          Добавить строку
        </button>

        {total !== null && (
          <span className="line-items-total">
            Итого: {formatNumber(total)} ₸
          </span>
        )}

        <button onClick={submit}>Создать платеж</button>
      </div>

      {error && <p className="line-items-error">{error}</p>}
    </div>
  );
}
